<!-- eslint-disable vue/no-unused-vars -->
<template>
  <fragment>
    <v-card class="rounded-lg">
      <v-card-subtitle>
        <h4>{{ $t('sales.summary') }}</h4>
      </v-card-subtitle>
      <v-card-text>
        <v-simple-table dense class="rounded-lg elevation-1">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center">{{ $t('sales.registration_date') }}</th>
                <th class="text-center">{{ $t('sales.buyer') }}</th>
                <th class="text-center">{{ $t('sales.purchase_value') }}</th>
                <th class="text-center">{{ $t('sales.ticket_itens') }}</th>
                <th class="text-center">{{ $t('sales.ticket_payment_method_short') }}</th>
                <th class="text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in $ticketPackage.sendPackageInfo"
                :key="item.nome"
              >
                <td class="text-center">
                  {{ formatProductDateToTable(item.dthr) }}
                </td>
                <td class="text-center">
                  {{ item.nome || item.nome_consumidor }}
                </td>
                <td class="text-center">
                  {{
                    formatCurrency(item.total) ||
                    formatCurrency(item.valor_total)
                  }}
                </td>
                <td class="text-center">
                  {{ item.qtd_item || item.qtd_itens }}
                </td>
                <td class="text-center">{{ item.metodo_pagamento }}</td>
                <td class="text-center">
                  {{ formatOrderStatus(item.status) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6">
            <v-radio-group v-model="$ticketPackage.sendChannel">
              <template v-slot:label>
                <div class="d-flex flex-row justify-space-between">
                  <h4>{{ $t('sales.shipping_channel') }}</h4>
                </div>
              </template>
              <v-radio
                value="EMAIL"
                class="rounded-lg pa-2"
                style="border: 1px solid rgb(0 0 0 / 42%)"
                active-class="active-class"
              >
                <template v-slot:label>
                  <div>
                    {{ $t('sales.package_email') }}<br />
                    <small>{{ $t('sales.email_channel_info') }}</small>
                  </div>
                </template>
              </v-radio>
              <!-- <v-radio
                value="SMS"
                class="rounded-lg pa-2"
                style="border: 1px solid rgb(0 0 0 / 42%)"
                active-class="active-class"
              >
                <template v-slot:label>
                  <div>
                    SMS<br />
                    <small> Habilita o envio de midias por SMS.</small>
                  </div>
                </template>
              </v-radio> -->
              <v-radio
                value="WHATSAPP"
                class="rounded-lg pa-2"
                style="border: 1px solid rgb(0 0 0 / 42%)"
                active-class="active-class"
              >
                <template v-slot:label>
                  <div>
                    WhatsApp<br />
                    <small> {{ $t('sales.whatsapp_channel_info') }}</small>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" sm="6">
            <v-radio-group v-model="$ticketPackage.sendType">
              <template v-slot:label>
                <div class="d-flex flex-row justify-space-between">
                  <h4>{{ $t('sales.send_type') }}</h4>
                </div>
              </template>
              <v-radio
                value="MULTIPLO"
                class="rounded-lg pa-2"
                style="border: 1px solid rgb(0 0 0 / 42%)"
                active-class="active-class"
              >
                <template v-slot:label>
                  <div>
                    {{ $t('sales.multiple') }}<br />
                    <small>{{ $t('sales.send_multiple_info') }}</small>
                  </div>
                </template>
              </v-radio>
              <v-radio
                value="UNICO"
                class="rounded-lg pa-2"
                style="border: 1px solid rgb(0 0 0 / 42%)"
                active-class="active-class"
              >
                <template v-slot:label>
                  <div>
                    {{ $t('sales.unique') }}<br />
                    <small
                      >{{ $t('sales.send_unique_info') }}</small
                    >
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-card-text>
      <v-card-text>
        <v-card elevation="0">
          <v-card-title class="pa-0 pb-2">
            <h4 class="text-center text-sm-start">
              {{ `${itemsTitle} - ${$ticketPackage.sendChannel}` }}
            </h4>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="mr-md-2 mb-2 mb-md-0"
              :width="mdAndUp ? 'auto' : '100%'"
              small
              @click="exportTrigger()"
            >
              {{ $t('sales.export_model') }}
              <v-icon small class="d-flex justify-center align-center ml-2">
                {{ $config.icons.download }}
              </v-icon>
            </v-btn>
            <v-btn
              small
              color="primary"
              :width="mdAndUp ? 'auto' : '100%'"
              :loading="isSelecting"
              @click="handleFileImport"
            >
              <span v-if="smAndUp"> {{ $t('sales.import_save_carriers') }}</span>
              <span v-else>{{ $t('sales.import_save') }} <br />{{ $t('sales.carriers') }}</span>
              <v-icon small class="d-flex justify-center align-center ml-2">
                {{ $config.icons.upload }}
              </v-icon>
            </v-btn>

            <input
              ref="uploader"
              class="d-none"
              type="file"
              @change="onFileChanged"
            />
          </v-card-title>
          <v-data-table
            :headers="sendTypeTableHeader"
            :items="$ticketPackage.packageToSent"
            :header-props="{ class: 'rounded-lg' }"
            :footer-props="{
              itemsPerPageOptions: [10, 20, 50],
              itemsPerPageText: this.$t('sales.product_itens_per_page'),
            }"
            class="elevation-1 rounded-lg"
          >
            <template v-slot:item.img_produto="{ item }">
              <v-img
                :src="item.img_produto"
                :alt="item.dsc_produto"
                width="50"
                height="50"
                contain
              ></v-img>
            </template>
            <template v-slot:item.dsc_produto="{ item }">
              <span
                :style="{
                  color: colorItemStatusCA(item.status),
                }"
              >
                {{ item.descricao_completa }}
              </span>
            </template>
            <template v-slot:item.dthr_visitacao="{ item }">
              <span
                :style="{
                  color: colorItemStatusCA(item.status),
                }"
              >
                {{ formatProductDateToTable(item.dthr_visitacao) }}
              </span>
            </template>
            <template
              v-slot:item.portador_nome="props"
              :class="'no-data-column'"
            >
              <div
                :style="{
                  'pointer-events': pointerItemStatusCA(props.item.status),
                }"
              >
                <v-edit-dialog
                  :return-value.sync="props.item.portador_nome"
                  large
                  persistent
                  :save-text="$t('sales.edit_save')"
                  :cancel-text="$t('sales.ticket_cancel')"
                >
                  <div class="d-flex flex-row align-center justify-center">
                    <p class="my-0 mr-2">{{ props.item.portador_nome }}</p>
                    <EditIcon
                      :color="colorItemStatusCA(props.item.status)"
                      size="x-small"
                    />
                  </div>
                  <template v-slot:input>
                    <div class="mt-2 text-subtitle-1">{{ $t('sales.change_name') }}</div>
                    <v-text-field
                      v-model="props.item.portador_nome"
                      type="text"
                      :label="$t('sales.carrier_name')"
                      single-line
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </div>
            </template>
            <template v-slot:item.portador_doc="props">
              <div
                :style="{
                  'pointer-events': pointerItemStatusCA(props.item.status),
                }"
              >
                <v-edit-dialog
                  :return-value.sync="props.item.portador_doc"
                  large
                  persistent
                  :save-text="$t('sales.edit_save')"
                  :cancel-text="$t('sales.ticket_cancel')"
                >
                  <div class="d-flex flex-row align-center">
                    <p class="my-0 mr-2">{{ props.item.portador_doc }}</p>
                    <EditIcon
                      :color="colorItemStatusCA(props.item.status)"
                      size="x-small"
                    />
                  </div>
                  <template v-slot:input>
                    <div class="mt-2 text-subtitle-1">{{ $t('sales.change_document') }}</div>
                    <v-text-field
                      v-model="props.item.portador_doc"
                      v-mask="[
                        '###.###.###-##',
                        '##.###.###/####-##',
                        'XX######',
                      ]"
                      type="tel"
                      :label="$t('sales.document')"
                      single-line
                      autofocus
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </div>
            </template>
            <template v-slot:item.portador_email="props">
              <div
                :style="{
                  'pointer-events': pointerItemStatusCA(props.item.status),
                }"
              >
                <v-edit-dialog
                  :return-value.sync="props.item.portador_email"
                  large
                  persistent
                  :save-text="$t('sales.edit_save')"
                  :cancel-text="$t('sales.ticket_cancel')"
                >
                  <div class="d-flex flex-row align-center">
                    <p class="my-0 mr-2">{{ props.item.portador_email }}</p>
                    <EditIcon
                      :color="colorItemStatusCA(props.item.status)"
                      size="x-small"
                    />
                  </div>
                  <template v-slot:input>
                    <div class="mt-2 text-subtitle-1">{{ $t('sales.change_email') }}</div>
                    <v-text-field
                      v-model="props.item.portador_email"
                      type="email"
                      :label="$t('sales.package_email')"
                      single-line
                      autofocus
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </div>
            </template>
            <template v-slot:item.portador_celular="props">
              <div
                :style="{
                  'pointer-events': pointerItemStatusCA(props.item.status),
                }"
              >
                <v-edit-dialog
                  :return-value.sync="props.item.portador_celular"
                  large
                  persistent
                  :save-text="$t('sales.edit_save')"
                  :cancel-text="$t('sales.ticket_cancel')"
                >
                  <div class="d-flex flex-row align-center">
                    <p class="my-0 mr-2">{{ props.item.portador_celular }}</p>
                    <EditIcon
                      :color="colorItemStatusCA(props.item.status)"
                      size="x-small"
                    />
                  </div>
                  <template v-slot:input>
                    <div class="mt-2 text-subtitle-1">{{ $t('sales.change_cellphone') }}</div>
                    <v-text-field
                      v-model="props.item.portador_celular"
                      v-mask="['(##) #####-####', '(##) ####-####']"
                      type="tel"
                      :label="$t('sales.ticket_cellphone')"
                      single-line
                      autofocus
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </div>
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="d-flex align-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      class="info-tool"
                      :disabled="isItemStatusCA(item.status)"
                    >
                      <v-icon
                        :color="'black'"
                        @click="
                          $ticketPackage.removeMidia(
                            item,
                            $t('sales.cancel_media_confirmation')
                          )
                        "
                        style="font-size: medium"
                        >mdi-cancel</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>
                    <strong>{{ $t('sales.cancel_media') }}</strong>
                  </span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      class="info-tool"
                      :loading="item.loading"
                      :disabled="isItemStatusCA(item.status)"
                      :color="item.sended ? 'green' : 'black'"
                      @click="saveItem(item)"
                    >
                      <v-icon style="font-size: large"
                        >mdi-content-save-outline</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>
                    <strong>{{ $t('sales.save_carrier_infos') }}</strong><br />
                    <span>{{ $t('sales.carrier_details') }}</span>
                  </span>
                </v-tooltip>
                <v-menu
                  bottom
                  right
                  transition="slide-y-transition"
                  :offset-y="true"
                >
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="{ ...tooltip, ...menu }"
                          :disabled="isItemStatusCA(item.status)"
                        >
                          <v-icon :color="'black'" style="font-size: large"
                            >mdi-send-variant-outline</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>
                        <strong>{{ $t('sales.send_media') }}</strong>
                      </span>
                    </v-tooltip>
                  </template>
                  <v-list class="d-flex flex-row py-0">
                    <v-list-item class="px-1">
                      <v-btn
                        icon
                        @click="() => $ticketPackage.sendAPackageItem('EMAIL', item)"
                      >
                        <MailIcon color="black" />
                      </v-btn>
                    </v-list-item>
                    <!-- <v-list-item class="px-1">
                      <v-btn
                        icon
                        @click="$ticketPackage.sendAPackageItem('SMS', item)"
                      >
                        <SMSIcon color="black" />
                      </v-btn>
                    </v-list-item> -->
                    <v-list-item class="px-1">
                      <v-btn
                        icon
                        @click="() => $ticketPackage.sendAPackageItem('WHATSAPP', item)"
                      >
                        <WhatsAppIcon />
                      </v-btn>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snack = false"> Fechar </v-btn>
      </template>
    </v-snackbar>
    <ConfirmDialog
      :dialogText="$ticketPackage.text"
      @callback="() => $ticketPackage.cancelMidia()"
    />
  </fragment>
</template>
<script>
import {
  formatCurrency,
  formatProductDate,
  formatProductDateToTable,
  formatOrderStatus,
} from "@/utils/productPackage.js";
import { normalizeString } from "../../utils";
import { displayHelpers } from "@/mixins/breakpoints.mixins";
import { exportFunction } from "@/mixins/exportFunction";
import ConfirmDialog from "@/components/global/ConfirmDialog.vue";
import EditIcon from "@/components/icons/EditIcon.vue";
import MailIcon from "@/components/icons/MailIcon.vue";
// import SMSIcon from "@/components/icons/SMSIcon.vue";
import WhatsAppIcon from "@/components/icons/WhatsAppIcon.vue";
export default {
  name: "SendPackageForm",
  mixins: [exportFunction, displayHelpers],
  components: {
    EditIcon,
    MailIcon,
    // SMSIcon,
    WhatsAppIcon,
    ConfirmDialog,
  },
  data() {
    return {
      formatCurrency,
      formatProductDate,
      formatProductDateToTable,
      formatOrderStatus,
      normalizeString,
      max25chars: v => v?.length <= 25 || this.$t('sales.characters_limit'),
      isSelecting: false,
      selectedFile: null,
      headersToMultiBearers: [
        {
          text: this.$t('sales.product_image'),
          value: "img_produto",
          sortable: false,
          align: "center",
        },
        { text: this.$t('sales.product'), value: "dsc_produto", align: "center" },
        { text: this.$t('sales.presentation_date'), value: "dthr_visitacao", align: "center" },
        {
          text: this.$t('sales.carriers_name'),
          value: "portador_nome",
          align: "center",
        },
        {
          text: this.$t('sales.carrier_document'),
          value: "portador_doc",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t('sales.carrier_email'),
          value: "portador_email",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t('sales.carrier_cellphone'),
          value: "portador_celular",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t('sales.actions'),
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      headerToOnlyOneBeaerer: [
        {
          text: this.$t('sales.product_image'),
          value: "img_produto",
          sortable: false,
          align: "center",
        },
        { text: this.$t('sales.product'), value: "dsc_produto", align: "center" },
        { text: this.$t('sales.presentation_date'), value: "dthr_visitacao", align: "center" },
        {
          text: this.$t('sales.carriers_name'),
          value: "portador_nome",
          align: "center",
        },
        {
          text: this.$t('sales.carrier_document'),
          value: "portador_doc",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t('sales.actions'),
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      rules: [
        value => !!value || "Required.",
        value => (value && value.length >= 3) || "Min 3 characters",
      ],
      snack: false,
      snackColor: "",
      snackText: "",
    };
  },
  computed: {
    isItemStatusCA() {
      return status => status === "CA";
    },
    itemsTitle() {
      if (this.$ticketPackage.sendType === "UNICO") return this.$t('sales.unique_send');
      return this.$t('sales.unique_multiple');
    },
    blockedToChange() {
      return this.$ticketPackage.sendType === "UNICO";
    },
    sendTypeTableHeader() {
      if (this.$ticketPackage.sendType === "UNICO")
        return this.headerToOnlyOneBeaerer;
      return this.headersToMultiBearers;
    },
    sendTypeStructureModel() {
      const fileName = "portadores";
      if (this.$ticketPackage.sendType === "UNICO") {
        const tableHeader = ["portador_nome", "portador_doc"];
        const tableBody = ["Fulano da Silva", "123.456.789-10"];

        return {
          tableHeader,
          tableBody,
          fileName,
        };
      }

      const tableHeader = [
        "portador_nome",
        "portador_doc",
        "portador_email",
        "portador_celular",
      ];

      const tableBody = [
        "Fulano da Silva",
        "123.456.789-10",
        "fulanodasilva@email.com",
        "(11) 99999-9999",
      ];

      return {
        tableHeader,
        tableBody,
        fileName,
      };
    },
  },
  methods: {
    colorItemStatusCA(status) {
      if (status === "CA") return "grey";
      return "black";
    },
    pointerItemStatusCA(status) {
      if (status === "CA") return "none";
      return "auto";
    },
    exportTrigger() {
      const { tableHeader, tableBody, fileName } = this.sendTypeStructureModel;
      this.export(tableHeader, tableBody, fileName);
    },
    saveItem(item) {
      this.$ticketPackage.bearerRegister(item);
    },
    handleFileImport() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      // Trigger click on the FileInput
      this.$refs.uploader.click();
    },
    onFileChanged(file) {
      const $this = this;
      const sendType = this.$ticketPackage.sendType;
      var packageStructure = this.$ticketPackage.packageToSent;
      var reader = new FileReader();
      this.selectedFile = file.target.files[0];

      reader.readAsText(this.selectedFile);

      reader.onload = function (event) {
        // Read file data
        var csvdata = event.target.result;

        // Split by line break to gets rows Array
        var rowsData = csvdata.split("\n");

        var removedHeaderAndEmpty = rowsData.filter(
          (item, index) => index !== 0 && item !== ""
        );

        if (sendType === "UNICO") {
          const data = removedHeaderAndEmpty.map(item => {
            const [portador_nome, portador_doc] = item.split(",");

            const documentFormatChecker =
              $this.$ticketPackage.isDocumentFormatAndLength(portador_doc);

            var docFormatted = portador_doc;

            if (!documentFormatChecker) {
              docFormatted = $this.$ticketPackage.documentFormat(portador_doc);
            }

            return {
              portador_nome,
              portador_doc: docFormatted,
            };
          });

          packageStructure.map((item, index) => {
            const { portador_nome, portador_doc } = data[index];
            item.portador_nome = normalizeString(portador_nome);
            item.portador_doc = normalizeString(portador_doc);
          });

          $this.$ticketPackage.allBearersRegister(packageStructure);

          return;
        }

        const data = removedHeaderAndEmpty.map(item => {
          const [
            portador_nome,
            portador_doc,
            portador_email,
            portador_celular,
          ] = item.split(",");
          return {
            portador_nome,
            portador_doc,
            portador_email,
            portador_celular,
          };
        });

        data.forEach(item => {
          const documentFormatChecker =
            $this.$ticketPackage.isDocumentFormatAndLength(item.portador_doc);

          const phoneNumberFormatChecker =
            $this.$ticketPackage.isPhoneNumberFormatAndLength(
              item.portador_celular
            );

          if (!phoneNumberFormatChecker) {
            item.portador_celular = $this.$ticketPackage.phoneNumberFormat(
              item.portador_celular
            );
          }
          if (!documentFormatChecker) {
            item.portador_doc = $this.$ticketPackage.documentFormat(
              item.portador_doc
            );
          }
        });

        packageStructure.forEach((item, index) => {
          const {
            portador_nome,
            portador_doc,
            portador_email,
            portador_celular,
          } = data[index] ?? {};

          item.portador_nome = normalizeString(portador_nome);
          item.portador_doc = normalizeString(portador_doc);
          item.portador_email = normalizeString(portador_email);
          item.portador_celular = normalizeString(portador_celular);
        });

        $this.$ticketPackage.allBearersRegister(packageStructure);
      };
    },
  },
};
</script>
<style scoped>
.v-small-dialog__activator {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.v-small-dialog__activator .disabled {
  cursor: not-allowed;
  pointer-events: none;
}

.info-tool {
  width: 1rem;
  height: 1rem;
  border-radius: 50px;
  margin-right: 0.625rem;
  cursor: pointer;
}

.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}

.v-dialog {
  overflow-y: unset !important;
  border-radius: 50px;
}

.modal-header {
  padding: 10px;
}
</style>
